export default __webpack_public_path__ + "static/media/EP05_ERYTHREE.32e67d3d.mp3";